import { atom } from "recoil"

/**
 * 連絡詳細関連のキャッシュをスキップするためのフラグ
 *
 * デフォルトはtrue（初回ロード時はキャッシュをスキップしてAPIから最新データを取得）
 * Pull-to-Refresh時にtrueに設定し、API呼び出し後にfalseに戻す。
 * これにより、ブラウザリロード時やPull-to-Refresh時に最新データを取得できる。
 *
 * 対象セレクタ:
 * - contactDetailSelectorFamily
 * - contactReplyThreadsSelectorFamily
 * - teamMemberContactsSelectorFamily
 */
export const contactDetailCacheSkipState = atom<boolean>({
  key: "atoms/contact/contactDetailCacheSkipState",
  default: true, // 初回ロード時はキャッシュをスキップ
})
